import type { SidebarRow } from './planner-virtual-row';

// Row height for the virtualized list (matches WhatsappContactBox padding + content).
export const ROW_HEIGHT = 96;
// The "Upcoming" / "Earlier" separator is a label, not a card, so it gets its own (much smaller) height.
export const DIVIDER_HEIGHT = 28;
// #508 — the paused-series block (reason wrapping to at most 2 lines of ~14px, beside a 22px Resume pill,
// plus its 6px gap) sits under the meta line; a 2-line title already fills ROW_HEIGHT, so a paused row grows
// by this much.
export const PAUSED_ROW_EXTRA = 38;

export function plannerRowHeight(row: SidebarRow | undefined, pausedRowIds: ReadonlySet<string>): number {
    if (row?.kind === 'divider') return DIVIDER_HEIGHT;
    if (row?.kind === 'item' && pausedRowIds.has(String(row.item._id))) return ROW_HEIGHT + PAUSED_ROW_EXTRA;
    return ROW_HEIGHT;
}
